import React from "react";
import NavBar from "../components/NavBar/NavBar";
import HeroSection from "../components/Shopify/HeroSection";
import HowItWorksSection from "../components/Shopify/HowItWorks";
import FormSection from "../components/Shopify/FormSection";
import FeatureSection from "../components/Shopify/FeaturesSection";
export default function ShopifyPage() {
  return (
    <>
      <NavBar />
      <div className="flex flex-col min-h-screen bg-grey-100 ">
        <main className="flex-1">
          <HeroSection />
          {/* <HowItWorksSection />
          <FeatureSection /> */}
          <FormSection />
        </main>
      </div>
    </>
  );
}
